import { createContext, useContext } from "react";

import type { TenantContext } from "@/api/types";

export type TenantScope = {
  slug: string;
  context: TenantContext;
  /** UI convenience only; the API enforces every permission server-side. */
  can: (code: string) => boolean;
};

export const TenantScopeContext = createContext<TenantScope | null>(null);

export function useTenant(): TenantScope {
  const value = useContext(TenantScopeContext);
  if (!value) throw new Error("useTenant must be used inside a tenant route");
  return value;
}

export function useOptionalTenant(): TenantScope | null {
  return useContext(TenantScopeContext);
}
